import {
  type CountryCode,
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

export type CountryOption = {
  iso: CountryCode;
  dial: string;
  label: string;
};

/** Digits only, E.164 without plus — e.g. 972549913008 */
export function toWaPhoneDigits(input: string, country: CountryCode) {
  const raw = (input || "").trim();
  const parsed = raw.startsWith("+")
    ? parsePhoneNumberFromString(raw)
    : parsePhoneNumberFromString(raw, country);
  if (!parsed || !parsed.isValid()) return null;
  return parsed.format("E.164").replace(/\D/g, "");
}

export function validateParentPhone(national: string, country: CountryCode) {
  const raw = (national || "").trim();
  if (!raw) return { ok: false as const, error: "empty" };
  const parsed = raw.startsWith("+")
    ? parsePhoneNumberFromString(raw)
    : parsePhoneNumberFromString(raw.replace(/\D/g, ""), country);
  if (!parsed || !parsed.isValid() || !isValidPhoneNumber(parsed.number)) {
    return { ok: false as const, error: "invalid" };
  }
  const phone = parsed.format("E.164").replace(/\D/g, "");
  return { ok: true as const, phone, e164: parsed.format("E.164") };
}

export function listCountries(): CountryOption[] {
  return getCountries()
    .map((iso) => ({
      iso,
      dial: `+${getCountryCallingCode(iso)}`,
      label: iso,
    }))
    .sort((a, b) => a.dial.localeCompare(b.dial, undefined, { numeric: true }));
}

export function formatPhoneDisplay(digits: string) {
  const parsed = parsePhoneNumberFromString(`+${digits.replace(/\D/g, "")}`);
  if (parsed) return parsed.formatInternational();
  return `+${digits}`;
}
